export default {
  "en": {
    "name": "English",
    "country": "United States of America",
    "flagEmoji": "🇺🇸"
  },
  "pt-BR": {
    "name": "Português do Brasil",
    "country": "Brazil",
    "flagEmoji": "🇧🇷"
  }
}
